module.exports = __webpack_public_path__ + "img/LAL_login_LOGO_L.0a0eee4c.svg";